var React = require('react');

function Group3 (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(0 .5)"},[React.createElement("circle",{"cx":"22.5","cy":"22.5","r":"22.5","fill":"#E4E4EB","key":0}),React.createElement("path",{"fill":"#505068","fillRule":"nonzero","d":"M28.51 10.505l-3.118-.005c-3.503 0-5.767 2.318-5.767 5.906v2.724H16.49a.49.49 0 0 0-.49.49v3.945c0 .27.22.49.49.49h3.135v9.956c0 .27.22.489.49.489h4.091c.271 0 .49-.22.49-.49v-9.956h3.666a.49.49 0 0 0 .49-.489l.002-3.946a.49.49 0 0 0-.49-.49h-3.668v-2.308c0-1.11.265-1.673 1.713-1.673h2.101c.27 0 .49-.22.49-.49v-3.664a.49.49 0 0 0-.49-.489z","key":1})]));
}

Group3.defaultProps = {"width":"45","height":"46","viewBox":"0 0 45 46"};

module.exports = Group3;

Group3.default = Group3;
